// @flow
/** @jsx h */

import { h } from 'preact'
import styles from '../../ResultItem.css'
import { bem } from '../../../../../../../../helpers/bem'

type Props = {
  value: number,
  hidden?: boolean
}

export function Number ({ value, hidden = true }: Props) {
  return (
    <div className={bem(styles['resultItem__score'], hidden ? 'hidden' : '')}>
      <span className={styles['resultItem__score-text']}>
        {prettyPrintNumber(value)}
      </span>
    </div>
  )
}

const prettyPrintNumber = (value: number): string => value.toLocaleString()



// WEBPACK FOOTER //
// ./src/shared/components/Result/components/ResultList/components/ResultItem/components/Number/Number.js